module.exports = __webpack_public_path__ + "d6413ba1/img/google.68f3823e.svg";